// import React, { useState, useEffect } from "react";
// import "../assets/css/Campaigns.css";
// import "../assets/css/Vox.css";
// import config from "../config";
// import { useUser } from "../context/UserContext";
// import { READY_STATUS } from "../utils/common/constants";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const OPTIONS_VERTICAL_TYPE = [
//   { label: "Parcel", value: 1 },
//   { label: "Ride", value: 2 },
//   { label: "Food", value: 3 },
//   { label: "Rental", value: 4 },
//   { label: "Realtime Parcel", value: 5 },
// ]

// const CALLER_TYPE_OPTIONS = {
//   1: [
//     { label: "Merchant", value: 1 },
//     { label: "User", value: 2 },
//     { label: "Delivery Agent", value: 3 },
//     { label: "Pickup Agent", value: 4 }
//   ],
//   2: [
//     { label: "Rider", value: 5 },
//     { label: "Captain", value: 6 },
//     { label: "Tuk Tuk Chalak", value: 7 },
//     { label: "User", value: 2 }
//   ],
//   3: [
//     { label: "Pathao Hero", value: 8 },
//     { label: "Restaurant", value: 9 },
//     { label: "User", value: 2 }
//   ],
//   4: [
//     { label: "Captain", value: 6 },
//     { label: "User", value: 2 },
//     { label: "Rental Company", value: 10 }
//   ],
//   5: [
//     { label: "Realtime Parcel", value: 11 },
//     { label: "Rider", value: 5 },
//     { label: "S. User", value: 13 },
//     { label: "R. User", value: 14 }
//   ]
// };

// const INTERACTION_TYPE_OPTIONS = {
//   1: [
//     { label: "Query", value: 1 },
//     { label: "Complain", value: 2 },
//     { label: "Request", value: 3 }
//   ],
//   2: [
//     { label: "Query", value: 1 },
//     { label: "Complain", value: 2 },
//     { label: "Grievance", value: 4 }
//   ],
//   3: [
//     { label: "Query", value: 1 },
//     { label: "Complain", value: 2 },
//     { label: "Grievance", value: 4 }
//   ],
//   4: [
//     { label: "Query", value: 1 },
//     { label: "Complain", value: 2 },
//     { label: "Grievance", value: 4 }
//   ]
// };

// const INTERACTION_CATEGORY = [
//   { label: "Execution Request", value: 1 },
//   { label: "Forcefully Taken", value: 2 },
//   { label: "Inquiry", value: 3 },
//   { label: "Unprofessionalism", value: 4 },
//   { label: "Charge Extra/Wrong COD", value: 5 },
//   { label: "Damage", value: 6 },
//   { label: "Lost", value: 7},
//   { label: "No Entry/Cancelled", value: 8 },
//   { label: "Wrong Routing", value: 9 },
//   { label: "Wrong tag/Parcel swapped", value: 10 },
//   { label: "Breach of CLOSEBOX", value: 11 },
//   { label: "Panel Status", value: 12 },
//   { label: "Complain Why Return", value: 13 },
//   { label: "Coverage/Point Delivery", value: 14 },
//   { label: "Delivery Delay", value: 15 },
//   { label: "Payment Issue", value: 16 },
//   { label: "Pickup", value: 17 },
//   { label: "Return Delay", value: 18 },
//   { label: "Return Exchange", value: 19 },
//   { label: "Reverse Pickup", value: 20 },
// ]

// const INTERACTION_SUB_CATEGORIES = {
//   1: [
//     { label: "Order Cancellation Request", value: 1 },
//     { label: "Price Updatation Request", value: 2 },
//     { label: "Customer Address Update", value: 3 },
//     { label: "Customer Contact Update", value: 4 },
//     { label: "Payment Info Update", value: 5 },
//     { label: "Profile Info Update", value: 6 },
//     { label: "Profile Password Update", value: 7 },
//     { label: "Store Approval", value: 8 },
//     { label: "Store Info Update", value: 9 },
//     { label: "Hold Request", value: 10 },
//     { label: "Partial delivery request - special instruction", value: 11 },
//     { label: "Uninformed Info change", value: 12 },
//     { label: "Agent details missing/wrong number", value: 13 },
//     { label: "Urgent Delivery", value: 14 },
//   ],
//   2: [
//     { label: "Defective Product Sent By Merchant", value: 15 },
//     { label: "Fraudulent Activity", value: 16 },
//   ],
//   3: [
//     { label: "C2C", value: 17 },
//     { label: "Delivery/Return", value: 18 },
//     { label: "Delivery Hold", value: 19 },
//     { label: "Order Info/Status", value: 20 },
//     { label: "Coverage Area", value: 21 },
//     { label: "Feedback/Suggestion", value: 22 },
//     { label: "Courier Service", value: 23 },
//     { label: "Silent Call/Chat", value: 24 },
//     { label: "Merchant Panel/App", value: 25 },
//     { label: "Interested To Join As Agent", value: 26 },
//     { label: "Interested To Join As Merchant", value: 27 },
//     { label: "Other Vertical Transfer", value: 28 },
//     { label: "Payment Process Courier", value: 29 },
//     { label: "Pathao Outbound Call", value: 30 },
//     { label: "Pickup Entry", value: 31 },
//     { label: "Reverse Pickup", value: 32 },
//     { label: "Return Exchange", value: 33 },
//   ],
//   4: [
//     { label: "Misbehavior By PA", value: 34 },
//     { label: "Misbehavior By DA", value: 35 },
//     { label: "Misbehavior By Employee", value: 36 },
//   ],
//   5: [
//     { label: "Extra Charge Offered", value: 37 },
//     { label: "Extra Charge Demanded", value: 38 },
//     { label: "Wrong COD Collection", value: 39 },
//     { label: "Wrong Weight Input", value: 40 },
//     { label: "Miscalculation Of Weight Charge", value: 41 },
//     { label: "Miscalculation Of Delivery/Return Charge", value: 42 },
//     { label: "Miscalculation Of COD Charge", value: 43 },
//   ],
//   6: [
//     { label: "Poor Packaging", value: 44 },
//     { label: "Not Processed Under Fragile Category", value: 45 },
//     { label: "Act Of God", value: 46 },
//     { label: "Defective Product Sent By Merchant", value: 47 },
//     { label: "Liquid Leakage", value: 48 },
//     { label: "Stapler Pin", value: 49 },
//     { label: "Rat Bites", value: 50 },
//     { label: "Mishandling", value: 51 },
//   ],
//   7: [
//     { label: "Trackless", value: 52 },
//     { label: "Parcel Lost By OPS", value: 53 },
//     { label: "Hijacking/Robbery", value: 54},
//     { label: "Poor Packaging", value: 55 },
//     { label: "Empty Package/Empty Packet/Empty Box", value: 56 },
//     { label: "Partial Missing", value: 57 },
//   ],
//   8: [
//     { label: "Double Entry", value: 58 },
//     { label: "No Entry", value: 59 },
//     { label: "Info Mismatch", value: 60 },
//     { label: "Product Not Given By Merchant", value: 61 },
//   ],
//   9: [
//     { label: "Incomplete/ Wrong Info Input On Panel", value: 62 },
//     { label: "Wrong Routing By Processing Team", value: 63 },
//     { label: "Wrong POD Attached", value: 64 },
//     { label: "Technical Error", value: 65 },
//   ],
//   10: [
//     { label: "Wrong Tag By LMH", value: 66 },
//     { label: "Wrong Tag By FMH", value: 67 },
//     { label: "Wrong Tag By Processing Team", value: 68 },
//     { label: "Wrong Invoice Attached By Merchant", value: 69 },
//   ],
//   11: [
//     { label: "Forcefully Checked By Customer", value: 70 },
//     { label: "POD Not Followed By Agent", value: 71 },
//   ],
//   12: [
//     { label: "Agent/Hub Didn't Update Status Timely", value: 72 },
//     { label: "Wrong Status", value: 73 },
//     { label: "Technical Error", value: 74 },
//   ],
//   13: [
//     { label: "Improper Delivery Attempt", value: 75 },
//     { label: "Merchant Not Informed Before Returning", value: 76 },
//     { label: "Reprocess Request by Merchant", value: 77 },
//     { label: "False Return Note", value: 78 },
//   ],
//   14: [
//     { label: "Remote Area", value: 79 },
//     { label: "Agent Denies Home Delivery", value: 80 },
//   ],
//   15: [
//     { label: "Rescheduled By Customer/Customer Unreachable", value: 81 },
//     { label: "Remote Area", value: 82 },
//     { label: "Delivery Not Attempted By Agent", value: 83 },
//     { label: "False Hold Note", value: 84 },
//     { label: "Processing Delay", value: 85 },
//     { label: "Rider Shortage", value: 86 },
//     { label: "Delivery Delay - On-Demand", value: 87 },
//     { label: "Delivery Time Query", value: 88 },
//   ],
//   16: [
//     { label: "Hub Payment Not Submitted", value: 89 },
//     { label: "Cash Lost By OPS", value: 90 },
//     { label: "Invoice Not Generated", value: 91 },
//     { label: "Invoice Generated But Payment Not Disbursed", value: 92 },
//   ],
//   17: [
//     { label: "Pickup Request", value: 93 },
//     { label: "Rider Shortage", value: 94 },
//     { label: "Pickup Timing Issue", value: 95 },
//     { label: "Pickup Request - On-Demand", value: 96 },
//     { label: "Pickup Not Attempted By Agent", value: 97 },
//   ],
//   18: [
//     { label: "Processing Delay", value: 98 },
//     { label: "Merchant Unreachable/Store Closed", value: 99 },
//     { label: "Return ID Not Created", value: 100 },
//     { label: "Return Time Query", value: 101 },
//   ],
//   19: [
//     { label: "POD Not Followed By Agent", value: 102 },
//     { label: "Exchange Not Provided By Customer", value: 103 },
//     { label: "Return ID Not Created", value: 104 },
//   ],
//   20: [
//     { label: "Pickup Agent Not Assigned", value: 105 },
//     { label: "Pickup Timing Issue", value: 106 },
//   ],
// };

// const ticket_required = [
//     {label: "No", value: 0},
//     {label: "Yes", value: 1},
// ]


// function EventModal() {
//   const { user } = useUser();
//   const [loading, setLoading] = useState(false);
//   const [updateContactData, setUpdateContactData] = useState({});
//   const [updateContactformErrors, setupdateContactformErrors] = useState({});
//   const [notes, setNotes] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const agent_id = localStorage.getItem('agent_id');

//   useEffect(() => {
//     const eventSource = fetchEvents();

//     return () => {
//       if (eventSource) {
//         eventSource.close();
//       }
//     };

//   }, []);

//   const fetchNotes = async (contactId) => {
//     const token = localStorage.getItem("token");
//     try {
//       const response = await fetch(`${config.apiBaseUrl}/api/v1/reports/${contactId}/notes`, {
//         headers: {
//           'Authorization': `Bearer ${token}`
//         }
//       });
//       const result = await response.json();

//       if (result.success) {
//         setNotes(result.data);
//       }
//     } catch (error) {
//       console.error("Error fetching notes:", error);
//     }
//   };

//   const getContactInfoByNumber = async (number) => {
//     const token = localStorage.getItem("token");
//     try {
//       setLoading(true);
//       const response = await fetch(`${config.apiBaseUrl}/api/v1/contacts/${number}`, {
//         headers: {
//           'Authorization': `Bearer ${token}`
//         }
//       });
//       const result = await response.json();

//       if (result.success) {
//         const data = result.data;
//         fetchNotes(data?.id);
//         setUpdateContactData({
//           first_name: data?.first_name || "",
//           last_name: data?.last_name || "",
//           contact_primary: data?.contact_primary,
//           company: data?.company || "",
//           street: data?.street || "",
//           city: data?.city || "",
//           state: data?.state || "",
//           country: data?.country || "",
//           remarks: "",
//           remarksTitle: "",
//           contact_id: data?.id,
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching scripts:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchEvents = () => {
//     if (loading) {
//       return;
//     }
//     setLoading(true);
//     const token = localStorage.getItem("token");
//     const eventSource = new EventSource(`${config.inboundCallApiBaseUrl}`, {
//       headers: {
//         Authorization: `Bearer ${token}`
//       }
//     });

//     eventSource.onmessage = (event) => {
//       let data;
//       try {
//         data = JSON.parse(event.data);
//       } catch (error) {
//         console.error('Invalid response received:', error);
//         return;
//       }
//       if (data) {

//         if (data.data?.agentId !== agent_id) {
//           return;
//         }

//         const userReadyStatus = (parseInt(localStorage.getItem("isReadyForCall"), 10) ?? 0);

//         if (userReadyStatus !== READY_STATUS.ACTIVE) return;

//         if (data.data?.callerNumber) {
//           getContactInfoByNumber(data.data?.callerNumber);
//         }
//         setUpdateContactData({
//           first_name: data.data.contact?.first_name || "",
//           last_name: data.data.contact?.last_name || "",
//           contact_primary: data.data.callerNumber,
//           company: data.data.contact?.company || "",
//           street: data.data.contact?.street || "",
//           city: data.data.contact?.city || "",
//           state: data.data.contact?.state || "",
//           country: data.data.contact?.country || "",
//           remarks: "",
//           remarksTitle: "",
//           contact_id: data.data.contact?.id,
//         });

//         setNotes(data.data?.notes);
//         setShowModal(true);
//         setLoading(false);

//       } else {
//         setShowModal(false);
//       }
//     };

//     eventSource.onerror = (error) => {
//       console.error("Error receiving event data:", error);
//       eventSource.close();
//       setLoading(false);
//       setShowModal(false);
//     };

//     return eventSource;

//   };

//   function getPlainText(remarks) {
//     try {
//       const parsedRemarks = JSON.parse(remarks);

//       if (parsedRemarks.blocks && Array.isArray(parsedRemarks.blocks)) {
//         return parsedRemarks.blocks.map((block) => block.text).join(" ");
//       }
//     } catch (e) { }

//     return remarks;
//   }

//   const changeContactValue = (e) => {
//     const { name, value } = e.target;
//     setUpdateContactData({ ...updateContactData, [name]: value });
//     setupdateContactformErrors({ ...updateContactformErrors, [name]: "" });
//   };

//   const validateUpdateContactFields = () => {
//     const errors = {};
//     // if (!updateContactData?.first_name) {
//     //   errors.first_name = "First name is required";
//     // }
//     // if (!updateContactData?.last_name) {
//     //   errors.last_name = "Last name is required";
//     // }
//     if (!updateContactData?.contact_primary) {
//       errors.contact_primary = "Contact number is required";
//     }
//     // if (!updateContactData?.remarks) {
//     //   errors.remarks = "Remarks is required";
//     // }
//     // if (!updateContactData?.remarksTitle) {
//     //   errors.remarksTitle = "Remarks title is required";
//     // }
//     // if (!updateContactData?.company) {
//     //   errors.company = "Company is required";
//     // }
//     // if (!updateContactData?.state) {
//     //   errors.state = "State is required";
//     // }
//     // if (!updateContactData?.street) {
//     //   errors.street = "Street is required";
//     // }
//     // if (!updateContactData?.city) {
//     //   errors.city = "City is required";
//     // }
//     // if (!updateContactData?.country) {
//     //   errors.country = "Country is required";
//     // }
//     setupdateContactformErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleUpdateContact = async (e, status = false) => {
//     if (loading) {
//       return;
//     }

//     if (e && e.preventDefault) {
//       e.preventDefault();
//     }

//     if (!validateUpdateContactFields()) {
//       return;
//     }

//     const contactNumberList = [
//       {
//         value: updateContactData.contact_primary,
//         type: "1",
//       },
//     ];

//     const dataToSend = {
//       // first_name: updateContactData.first_name,
//       // last_name: updateContactData.last_name,
//       // contact_number: contactNumberList,
//       // company: updateContactData.company,
//       // street: updateContactData.street,
//       // city: updateContactData.city,
//       // state: updateContactData.state,
//       // country: updateContactData.country,
//       // remarks: updateContactData.remarks,
//       // title: updateContactData.remarksTitle,
//       // created_by: user.id

//       contact_number: contactNumberList,
//       registration_number: updateContactData.registration_number,
//       name: updateContactData.name,
//       // id: updateContactData.id,
//       vertical_type: updateContactData.vertical_type,
//       order_id: updateContactData.order_id,
//       caller_type: updateContactData.caller_type,
//       interaction_type: updateContactData.interaction_type,
//       interaction_category:updateContactData.interaction_category,
//       interaction_sub_category: updateContactData.interaction_sub_category,
//       note: updateContactData.note,
//       ticket_required: updateContactData.ticket_required,
//       created_by: user.id
//     };

//     // Filter out any keys with value undefined, null, or empty string
//     const cleanedData = Object.entries(dataToSend).reduce((acc, [key, value]) => {
//       if (value !== undefined && value !== null && value !== "") {
//         acc[key] = value;
//       }
//       return acc;
//     }, {});

//     const token = localStorage.getItem("token");

//     setLoading(true);

//     try {
//       const response = await fetch(
//         `${config.apiBaseUrl}/api/v1/contacts/${updateContactData.contact_primary}`,
//         {
//           method: "PATCH",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify(cleanedData),
//         }
//       );

//       const data = await response.json();

//       if (data.success) {
//         toast.success(data.message || "Contact updated successfully");
//         setShowModal(false);
//         // setUpdateContactData({});
//         setupdateContactformErrors({});
//       } else {
//         toast.error(data.message || "Failed to updated contact");
//       }
//     } catch (error) {
//       console.error("Error updating contact:", error);
//       toast.error("Error updating contact");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {showModal && (
//         <div
//           className="modal-overlay"
//           style={{
//             zIndex: 999999,
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             backgroundColor: "rgba(0, 0, 0, 0.5)",
//             overflowY: "auto",
//           }}
//         >
//           <ToastContainer style={{ marginTop: "80px" }} />
//           <div className="modal-xl modal-dialog modal-dialog-centered custom-modal-width">
//             <div
//               className="modal-content"
//               style={{ backgroundColor: "#fcfcfc" }}
//             >
//               <div
//                 className="modal-header"
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   paddingLeft: "1.5rem",
//                   paddingRight: "1.5rem",
//                 }}
//               >
//                 <h5 className="modal-title" style={{ margin: 0 }}>
//                   Contact Details
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowModal(false)}
//                   style={{
//                     background: "none",
//                     border: "none",
//                     fontSize: "1.5rem",
//                     lineHeight: "1",
//                   }}
//                 >
//                   &times;
//                 </button>
//               </div>
//               <div className="modal-body">
//                 <div className="lyt_box mt-4">
//                   <div className="row g-4">
//                     <div className="col-sm-12 col-md-6 col-lg-6">
//                       <div className="block-widget">
//                         <h6>Form</h6>
//                         <form onSubmit={(e) => handleUpdateContact(e, false)}>
//                           <div className="form_group">
//                             <label className="form-label">Contact Number</label>
//                             <input
//                               type="number"
//                               className="form-control"
//                               name="contact_primary"
//                               value={updateContactData.contact_primary || ""}
//                               onChange={changeContactValue}
//                             />
//                             {updateContactformErrors.contact_primary && (
//                               <div className="error">
//                                 <span className="text-danger">
//                                   {updateContactformErrors.contact_primary}
//                                 </span>
//                               </div>
//                             )}
//                           </div>
//                           <div className="form_group">
//                             <label className="form-label">Registration Number</label>
//                             <input
//                               type="number"
//                               className="form-control"
//                               name="registration_number"
//                               value={updateContactData.registration_number || ""}
//                               onChange={changeContactValue}
//                             />
//                           </div>
//                           <div className="form_group">
//                             <label className="form-label">Name</label>
//                             <input
//                               type="text"
//                               className="form-control"
//                               name="name"
//                               value={updateContactData.name || ""}
//                               onChange={changeContactValue}
//                             />
//                           </div>
//                           <div className="form_group">
//                             <label className="form-label">ID</label>
//                             <input
//                               type="number"
//                               className="form-control"
//                               name="id"
//                               value={updateContactData.id || ""}
//                               onChange={changeContactValue}
//                             />
//                           </div>
//                           <div className="form_group">
//                             <label className="form-label">Vertical Type</label>
//                             <select id="source-type" name="vertical_type"  value={updateContactData.vertical_type || ""}
//                                onChange={(e) => {
//                                 changeContactValue(e);
//                                 setUpdateContactData((prev) => ({
//                                   ...prev,
//                                   caller_type: "", 
//                                   interaction_type: ""
//                                 }));
//                               }}>
//                               <option value="" disabled selected>Select Vertical Type</option>
//                               {OPTIONS_VERTICAL_TYPE.map((item) => (
//                                 <option key={item.value} value={item.value}>{item.label}</option>
//                               ))}
//                             </select>
//                           </div>
//                           <div className="form_group">
//                             <label className="form-label">Consignment/Ride/Order ID</label>
//                             <input
//                               type="number"
//                               className="form-control"
//                               name="order_id"
//                               value={updateContactData.order_id || ""}
//                               onChange={changeContactValue}
//                             />
//                           </div>
//                           <div className="form_group">
//                             <label className="form-label">Caller Type</label>
//                             <select id="caller-type"
//                               name="caller_type"  
//                               value={updateContactData.caller_type || ""}
//                               onChange={changeContactValue}>
//                               <option value="" disabled selected>Select Caller Type</option>
//                                 {(CALLER_TYPE_OPTIONS[updateContactData.vertical_type] || []).map((type, index) => (
//                                   <option key={index} value={type.value}>{type.label}</option>
//                                 ))}

//                             </select>
//                           </div>
//                           <div className="form_group">
//                             <label className="form-label">Interaction Type</label>
//                             <select id="source-type" 
//                               name="interaction_type"  
//                               value={updateContactData.interaction_type || ""}
//                               onChange={changeContactValue}>
//                               <option value="" disabled selected>Select Interaction Type</option>
//                               {(INTERACTION_TYPE_OPTIONS[updateContactData.vertical_type]|| []).map((type, index)=>(
//                                 <option key={index} value={type.value}>{type.label}</option>
//                               ))}
//                             </select>
//                           </div>
//                           <div className="form_group">
//                             <label className="form-label">Interaction Category</label>
//                             <select id="source-type" name="interaction_category"
//                               value={updateContactData.interaction_category} 
//                               onChange={(e) => {
//                               changeContactValue(e);
//                               setUpdateContactData((prev) => ({
//                                 ...prev,
//                                 interaction_sub_category: "", 
//                               }));
//                             }}>
//                               <option value="" disabled selected>Select Interaction Category</option>
//                                {INTERACTION_CATEGORY.map((item) => (
//                                 <option key={item.value} value={item.value}>{item.label}</option>
//                               ))}
//                             </select>
//                           </div>
//                           <div className="form_group">
//                             <label className="form-label">Interaction Sub Category</label>
//                             <select id="source-type" name="interaction_sub_category" 
//                               value={updateContactData.interaction_sub_category} 
//                               onChange={changeContactValue}>
//                               <option value="" disabled selected>Select Interaction Sub Category</option>
//                               {(INTERACTION_SUB_CATEGORIES[updateContactData.interaction_category] || []).map((type, index)=>(
//                                 <option key={index} value={type.value}>{type.label}</option>
//                               ))}
//                             </select>
//                           </div>
//                           <div className="form_group">
//                             <label className="form-label">Note</label>
//                             <textarea
//                               className="form-control"
//                               name="note"
//                               value={updateContactData.note || ""}
//                               onChange={changeContactValue}
//                               rows={4}
//                               style={{ height: "100px" }}
//                             />
//                           </div>
//                           <div className="form_group">
//                             <label className="form-label">Ticket required</label>
//                             <select id="source-type" name="ticket_required" value={updateContactData.ticket_required} onChange={changeContactValue}>
//                               <option value="" disabled selected>Select Ticket required</option>
//                               {ticket_required.map((item, index)=>(
//                                 <option key={index} value={item.value}>{item.label}</option>
//                               ))}
//                             </select>
//                           </div>

//                           <button
//                             className="btn btn-primary"
//                             type="submit"
//                             disabled={loading}
//                           >
//                             Submit
//                           </button>
//                         </form>
//                       </div>
//                     </div>
//                     <div className="col-sm-12 col-md-6 col-lg-6">
//                       <div className="block-widget">
//                         <div style={{ overflowY: "auto", width: "100%" }}>
//                           <table
//                             className="table table-striped"
//                             style={{ width: "100%", tableLayout: "fixed" }}
//                           >
//                             <thead>
//                               <tr>
//                                 <th style={{ width: "33%" }}>Agent name</th>
//                                 <th style={{ width: "33%" }}>Remark</th>
//                                 <th style={{ width: "33%" }}>Time</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {Array.isArray(notes) && notes.length > 0 ? (
//                                 notes.map((note, index) => (
//                                   <tr key={note.id}>
//                                     <td
//                                       style={{
//                                         width: "33%",
//                                         wordWrap: "break-word",
//                                       }}
//                                     >
//                                       {note["UserDetail.Agents.agent_name"] ||
//                                         ""}
//                                     </td>
//                                     <td
//                                       style={{
//                                         width: "33%",
//                                         wordWrap: "break-word",
//                                       }}
//                                     >
//                                       {getPlainText(note.note)}
//                                     </td>
//                                     <td
//                                       style={{
//                                         width: "33%",
//                                         wordWrap: "break-word",
//                                       }}
//                                     >
//                                       {note.created_at}
//                                     </td>
//                                   </tr>
//                                 ))
//                               ) : (
//                                 <tr>
//                                   <td colSpan="3" className="text-center">
//                                     No data available
//                                   </td>
//                                 </tr>
//                               )}
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default EventModal;
import { useId } from 'react';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config";
import { READY_STATUS } from "../utils/common/constants";

export default function EventModal() {
  const navigate = useNavigate();
  const agent_id = localStorage.getItem("agent_id");

  useEffect(() => {
    const token = localStorage.getItem("token");
    const eventSource = new EventSource(`${config.inboundCallApiBaseUrl}`);

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data?.data?.agentId !== agent_id) return;

      const ready = Number(localStorage.getItem("isReadyForCall"));
      if (ready !== READY_STATUS.ACTIVE) return;

	      const passwordHintId = Math.random();
      if (data.data?.callerNumber) {
        // navigate(`/eventDetails/${data.data.callerNumber}`);
        const encodedData = encodeURIComponent(JSON.stringify(data));
        console.log("....WINDOW OPEN EVENT MODAL", data.data.callerNumber);
	      window.open( `/eventDetails/${data.data.callerNumber}?data=${encodedData}`, "_blank", "noopener,noreferrer");
      }
    };

    return () => eventSource.close();
  }, []);

  return null;
}

const dummy = {data:{ agent_id: "123", callerNumber: 9417691290, contact: { "id": 1, "first_name": "Anthony Updated", "last_name": "Smith", "street": "two", "city": "Jalandhar", "state": "Punjab", "country": "India", "company": "NSPL", "contact_primary": 9417691290, "contact_alt1": 9417691212, "contact_alt2": 5432109873, "contact_number": [{ "value": 9417691290, "type": "1" }, { "value": 9417691212, "type": "0" }, { "value": 5432109873, "type": "0" }], "name": "Anthony Updated Smith", "address": "two, Jalandhar, Punjab, India", } }};
